/**
 * Header
 */

export default function Header() {
    const selectors = {
        'toggle' : '.js-scroll-top',
    };

    this.init = () => {
        this.scroll2Top();
    };

    this.scroll2Top = () => {

        jQuery(selectors.toggle).on('click', (e)=>{
            e.preventDefault();
            jQuery("html, body").animate({
                scrollTop: 0
            }, "slow");
            return false;
        })

        jQuery(window).on('scroll', () => {
            let top = jQuery(window).scrollTop();
            if(top > 100){
                jQuery(selectors.toggle).fadeIn();
            }else{
                jQuery(selectors.toggle).fadeOut();
            }
        })

    }

}
